import Registraion from './RegistraionContainer';
export default Registraion;